import { render } from "./CollapseTextCard.vue?vue&type=template&id=72dde22f&scoped=true"
import script from "./CollapseTextCard.vue?vue&type=script&lang=js"
export * from "./CollapseTextCard.vue?vue&type=script&lang=js"

import "./CollapseTextCard.vue?vue&type=style&index=0&id=72dde22f&scoped=true&lang=scss"

import exportComponent from "E:\\dive\\dive.fsd.vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72dde22f"]])

export default __exports__